import Color from "color";

export default function contrastColor(color: string): string {
    return Color(color).isDark() ? "#fff" : "#000";
}
